import { useRef, useState } from "react";
import { Button, Icon } from "@conuti-das/prince-ui";
import { Flex, princeIcon } from "@/ui-prince";

interface Props {
  value: string;
  onChange: (raw: string) => void;
}

export function EdifactInput({ value, onChange }: Props) {
  const fileRef = useRef<HTMLInputElement>(null);
  const [name, setName] = useState<string | null>(null);

  async function handleFile(f: File) {
    setName(f.name);
    onChange(await f.text());
  }

  return (
    <Flex direction="Column" style={{ gap: "var(--s-2)" }}>
      <label htmlFor="edi-input" className="prn-field-label">
        EDIFACT-Nachricht
      </label>
      <textarea
        id="edi-input"
        className="prn-input"
        value={value}
        onChange={(e) => onChange(e.target.value ?? "")}
        placeholder="UNA:+.? 'UNB+...'UNH+...'BGM+...'...'UNT+...'UNZ+...'"
        rows={10}
        style={{
          width: "100%",
          fontFamily: "var(--sapFontMonoFamily, monospace)",
          fontSize: "0.85rem",
          resize: "vertical",
        }}
      />
      <Flex style={{ alignItems: "center", gap: "var(--s-2)" }}>
        <Button variant="plain" onPress={() => fileRef.current?.click()}>
          <Icon name={princeIcon("upload")} size={16} />
          Datei laden
        </Button>
        {name && (
          <span style={{ color: "var(--sapContent_LabelColor)", fontSize: "0.85rem" }}>
            {name}
          </span>
        )}
        <input
          ref={fileRef}
          type="file"
          accept=".edi,.txt"
          style={{ display: "none" }}
          onChange={(e) => {
            const f = e.target.files?.[0];
            if (f) void handleFile(f);
          }}
        />
      </Flex>
    </Flex>
  );
}
